import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, Modal } from 'react-bootstrap';
import AreaN2DataService from "./services/arean2.service";
import PosicionDataService from "./services/posicion.service";
import { Navigate } from 'react-router-dom';

function NewPosicion(props) { 
    const [showerror, setShowerror] = useState(false);
    const [showsuccess, setShowsuccess] = useState(false);
    const [errmessage, setErrmessage] = useState('');
    const [succmessage, setSuccmessage] = useState('');
    const [lgShow, setLgShow] = useState(false);

    const [arean2id, setarean2id] = useState(props.arean2id);

    const [nombreposicion, setnombreposicion] = useState('');
    const [descripcionposicion, setdescripcionposicion] = useState('');
    
    const handleClose = () => setLgShow(false);  
    const handleShow = () => {
        // It seems this avoids the states to have a value when the modals first opens..
        // I thought the initialization of the variables worked for that purpose..
        // But may be this is needed because of the modal.
        setShowerror(false);
        setShowsuccess(false);
        setnombreposicion('');
        setdescripcionposicion('');
        setLgShow(true);         
    }
        
    const onChangeNombrePosicion = (e) => {
        setnombreposicion(e.target.value);
      } 
    
    const onChangeDescripcionPosicion = (e) => {
        setdescripcionposicion(e.target.value);
    } 
    
    const handleValidations = (e) => {
        if (nombreposicion.length == 0) {
            setErrmessage('Se requiere un nombre para la posición.');
            setShowerror(true);
            return;
        }
        savePosicion();
    }   
      
    let savePosicion = ()  =>{   
        var data = {
            nombreposicion: nombreposicion,
            descripcionposicion: descripcionposicion,
            arean2id: arean2id
        }    
        
        PosicionDataService.create(data)
        .then(response => {
            setSuccmessage('Posición agregada exitosamente.');
            setShowsuccess(true);
            props.retrieveAreaN2(props.arean2id);
            setLgShow(false);
        })
        .catch(e => {
          console.log(e);
          setErrmessage(e.response?e.response.data.message:e.message);
          setShowerror(true);
          setSuccmessage('');
          setShowsuccess(false);
        })        
    }  

    return (
        <>         
            <Button lg={8} variant='secondary' onClick={handleShow}>Agregar posición</Button>
            <Modal
                size="lg"
                show={lgShow}
                onHide={() => setLgShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                    {'Agregar área N2'}
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row className='mb-2 d-flex'>
                            <Col className='col-md-3' md={4}>
                                <FormLabel className='mb-2'>Nombre posición:</FormLabel>       
                                <FormControl style={{maxWidth:"300px"}} type="text" name="internalidentifier" id="internalidentifier" onChange={onChangeNombrePosicion} ></FormControl>
                            </Col>

                            <Col md={8}>
                                <FormLabel className='mb-2'>Descripción posición:</FormLabel>       
                                <FormControl type="text" name="sublocationdescription" id="sublocationdescription" onChange={onChangeDescripcionPosicion} ></FormControl>
                            </Col>          

                        </Row>
                        {showerror && (
                        <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                            <Alert.Heading>Error</Alert.Heading>
                            <p>{errmessage}</p>
                        </Alert>      
                        )}
                        {showsuccess && (
                        <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                            <Alert.Heading>Hecho</Alert.Heading>
                            <p>{succmessage}</p>
                        </Alert>      
                        )}     
                        <hr></hr>
                        <Row className='mb-2'>
                            <Col className='col-md-4'>
                                <Button className='btn-secondary' id='saveSublocation' onClick={handleValidations}>Guardar posición</Button>            
                            </Col>
                        </Row>          
                    </Container>    
                </Modal.Body>
            </Modal>
        </>
    );      
     
}

export default NewPosicion;

{/*
const EditLocationsPage = (props) => {    



  
  return (
    <>
      <Container>
        <Row className='mb-4'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h1 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>EDIT LOCATION</h1>

        <Row className='mb-4'>
            <FormLabel>Sublocations</FormLabel>
            <Col className='mb-4 col-md-4'>
                <Button variant='primary' className='md-4'>Add Sublocation</Button>
            </Col>
            
            
            <SublocationsList listOfSublocations = {listOfSublocations}></SublocationsList>            
        </Row>
                                   
      </Container>    
    </>
  )

}

export default EditLocationsPage;

*/} 